module.exports = {
	"1": "Русский",
	"2": "Қазақ тілі",
	"3": "Кыргызча",
	"4": "Тоҷикӣ",
	"5": "English"
};


//////////////////
// WEBPACK FOOTER
// ./js/shared/dictionaries/languages.json
// module id = 1822
// module chunks = 2